var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app_theme"}},[_c('navbar',{staticClass:"md:hidden"}),_c('gista-sidebar'),_c('gista-frame',[_c('div',{ref:"scrollArea",staticClass:"relative main-container md:my-0",attrs:{"id":"scrollAreaSolutip"}},[_c('transition',{attrs:{"name":"block","mode":"out-in"}},[_c('router-view')],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }